export default __webpack_public_path__ + "static/flights-2587664c738d8be69a9c7d28f96bfb03.png";